module.exports = __webpack_public_path__ + "img/ni.nief0b194.svg";